/**
 * Every failure this product can report, as a translation key into the `app`
 * namespace. One place, so a library can name an error without knowing how the
 * catalogues are laid out, and so a renamed key breaks the build rather than
 * printing itself on screen.
 *
 * Each key must exist in **both** `libs/i18n/src/resources/uk/app.json` and
 * `.../en/app.json` — a missing key is not an error, i18next renders the key.
 */
export const ERRORS = {
  /** Reading the key container and its certificates — `libs/kep`. */
  key: {
    missingFile: "errors.key.missingFile",
    wrongPassword: "errors.key.wrongPassword",
    unsupportedContainer: "errors.key.unsupportedContainer",
    noPrivateKey: "errors.key.noPrivateKey",
    certificatesNotFound: "errors.key.certificatesNotFound",
    certificateAuthorityUnreachable:
      "errors.key.certificateAuthorityUnreachable",
    certificateAuthorityNotDetected: "errors.key.certificateAuthorityNotDetected",
    certificateExpired: "errors.key.certificateExpired",
    signingFailed: "errors.key.signingFailed",
    timestampFailed: "errors.key.timestampFailed",
    noSigningKey: "errors.key.noSigningKey",
    sessionExpired: "errors.key.sessionExpired",
  },
  /** Talking to the ДПС fiscal server — `libs/fiscal`. */
  fiscal: {
    gatewayUnreachable: "errors.fiscal.gatewayUnreachable",
    notAuthorised: "errors.fiscal.notAuthorised",
    registerNotFound: "errors.fiscal.registerNotFound",
    serverUnavailable: "errors.fiscal.serverUnavailable",
    badRequest: "errors.fiscal.badRequest",
    noRegisters: "errors.fiscal.noRegisters",
    documentNotFound: "errors.fiscal.documentNotFound",
  },
  common: {
    unknown: "errors.common.unknown",
  },
} as const;
